module.exports = __webpack_public_path__ + "static/media/sprite.1de7d130.png";